<template>
  <div class="login-password">
    <BaseTitle tag="h2">Forgot Password</BaseTitle>
    <div class="login-password__body">
      <form @submit.prevent.stop="submitForgotPassword" ref="formPassword" novalidate>
        <ElementFormGroup :label="'Email'">
          <input
            :id="'password-email'"
            :name="'password-email'"
            :type="'email'"
            v-validate="`required|email`"
            v-model="email">
          <span class="error" v-if="errors.has('password-email')">Please inter a valid email adress</span>
        </ElementFormGroup>
        <button :class="submitClasses" type="submit">Submit</button>
        <a class="login-password__cancel" href="#" @click.prevent.stop="cancel">Cancel</a>
      </form>
    </div>
    <div class="login-password__info">An e-mail with a link to reset your password will be send.</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BaseTitle from '@base/BaseTitle'
import ElementFormGroup from '@elements/ElementFormGroup'

export default {
  name: 'TheLoginPassword',
  components: {
    BaseTitle,
    ElementFormGroup
  },
  data () {
    return {
      email: '',
      error: false,
      isSubmitting: false
    }
  },
  computed: {
    ...mapGetters({
      forgetPassword: 'auth/getForgetPassword'
    }),
    submitClasses () {
      return [
        { 'is-disabled': this.isSubmitting }
      ]
    },
    errorClass () {
      return { 'error': this.error }
    }
  },
  watch: {
    forgetPassword () {
      if (!this.forgetPassword) {
        this.isSubmitting = false
      }
    }
  },
  methods: {
    ...mapActions({
      requestLostPassword: 'auth/requestLostPassword',
      updateErrorType: 'auth/updateErrorType',
      updateForgetPassword: 'auth/updateForgetPassword'
    }),
    cancel () {
      this.email = ''
      this.error = false
      this.updateForgetPassword(false)
    },
    submitForgotPassword () {
      if (!this.isSubmitting) {
        this.$validator.validateAll().then(result => {
          this.error = !result
          this.isSubmitting = result
          if (result) this.requestLostPassword({ email: this.email })
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .login-password{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;

    // Title

    .title{
      order: 0;
      flex: 0 1 auto;
      width: 100%;
    }

    // Body

    &__body{
      order: 2;
      width: 100%;
      flex: 0 1 auto;
    }

    // Info

    &__info{
      @include form-info-error;
      order: 1;
    }

    // Cancel

    &__cancel{
      display: block;
      margin-top: 1rem;
      text-align: center;
      font-size: 1.4rem;
    }

    // Element Form Group

    .form-group{
      label {
        font-weight: font-weights("normal");
        margin-right: 0;
      }

      input {
        margin-bottom: 0;
      }
    }
  }
</style>
